// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fuG1","left":"styles_left__3ybwY","desktopActions":"styles_desktopActions__3285j","title":"styles_title__ku1yV"};